export const PATH_KEY_TO_POSITION = {
  menuIdx: 0,
  categoryIdx: 1,
  productIdx: 2,
  variantIdx: 3,
};

export const DIETARY_LABELS = [
  'Vegetarian',
  'Vegan',
  'Gluten-free',
  'Dairy-free',
];

export const AVAILABILITY_DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const MULTIPLE_ALLERGENS = 'May contain traces of multiple allergens';

export const ALLERGENS = [
  MULTIPLE_ALLERGENS,
  'Celery',
  'Crustaceans',
  'Eggs',
  'Fish',
  'Gluten',
  'Lupin',
  'Milk',
  'Molluscs',
  'Mustard',
  'Peanuts',
  'Sesame',
  'Sulphur dioxide/sulphites',
  'Soybeans',
  'Tree Nuts',
];

export const CHOICE_LIMIT_ZERO = 'Unlimited';

export const OPTION_GROUPS_MODALS = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  LIST: 'LIST',
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/constants/index.js